import { render } from "./StoreModuleTab.vue?vue&type=template&id=d00371e0&scoped=true&ts=true"
import script from "./StoreModuleTab.vue?vue&type=script&lang=ts"
export * from "./StoreModuleTab.vue?vue&type=script&lang=ts"

import "./StoreModuleTab.vue?vue&type=style&index=0&id=d00371e0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d00371e0"]])

export default __exports__